import React from 'react'

function INEReport() {
    return (
        <div className="sandbox_report_wrapper">
            <h2>Result report:</h2>
            <div class="api_log_list">
                <h4>Información Personal</h4>
                <div class="api_log_detail">
                    <span>Nombres</span>
                    <span class="api_log_detail_value">JUAN</span>
                </div>
                <div class="api_log_detail">
                    <span>Primer Apellido</span>
                    <span class="api_log_detail_value">MENA</span>
                </div>
                <div class="api_log_detail">
                    <span>Segundo Apellido</span>
                    <span class="api_log_detail_value">ALOVE</span>
                </div>
                <div class="api_log_detail">
                    <span>Género</span>
                    <span class="api_log_detail_value">HOMBRE</span>
                </div>
                <div class="api_log_detail">
                    <span>Fecha de Nacimiento</span>
                    <span class="api_log_detail_value">01/01/1972</span>
                </div>
                <div class="api_log_detail">
                    <span>País de Nacimiento</span>
                    <span class="api_log_detail_value">MEXICO</span>
                </div>
            </div>

            <div class="api_log_list">
                <h4>Detalles de Registro y Documentación</h4>
                <div class="api_log_detail">
                    <span>Prueba Documental</span>
                    <span class="api_log_detail_value">1 (Acta de nacimiento)</span>
                </div>
                <div class="api_log_detail">
                    <span>Entidad de Registro</span>
                    <span class="api_log_detail_value">DISTRITO FEDERAL</span>
                </div>
                <div class="api_log_detail">
                    <span>Municipio de Registro</span>
                    <span class="api_log_detail_value">-</span>
                </div>
                <div class="api_log_detail">
                    <span>Año de Registro</span>
                    <span class="api_log_detail_value">1972</span>
                </div>
                <div class="api_log_detail">
                    <span>Número de Acta</span>
                    <span class="api_log_detail_value">0000X</span>
                </div>
                <div class="api_log_detail">
                    <span>Clave de Municipio de Registro</span>
                    <span class="api_log_detail_value">017</span>
                </div>
                <div class="api_log_detail">
                    <span>Clave de Entidad de Registro</span>
                    <span class="api_log_detail_value">09 (Ciudad de México)</span>
                </div>
                <div class="api_log_detail">
                    <span>Tomo</span>
                    <span class="api_log_detail_value">-</span>
                </div>
                <div class="api_log_detail">
                    <span>Folio</span>
                    <span class="api_log_detail_value">-</span>
                </div>
                <div class="api_log_detail">
                    <span>Libro</span>
                    <span class="api_log_detail_value">-</span>
                </div>
            </div>

            <div class="api_log_list">
                <h4>Detalles Adicionales</h4>
                <div class="api_log_detail">
                    <span>Estado de CURP</span>
                    <span class="api_log_detail_value">RCN (Cambio de registro sin afectar CURP)</span>
                </div>
            </div>

        </div>
    )
}

export default INEReport